import styled from 'styled-components';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useGetGeolocationStatus } from '../../campus/hooks/useGelocationStatus';

export const GuestBenefits = () => {
    const { countryCode } = useGetGeolocationStatus();

    return (
        <GuestBenefitsWrapper>
            <h2>
                ¿Y qué beneficio obtienes como <i>invitado</i>?
            </h2>
            <p>
                Al unirte a ADEN accederás a una formación pensada para impulsar
                tu crecimiento profesional y el desarrollo de tu empresa,
                mientras te integras a la red de ejecutivos más amplia de
                América Latina.
            </p>
            <Line />
            {countryCode !== 'AR' && (
                <h3>
                    <label>
                        <Icon
                            icon="iconamoon:gift"
                            width="24"
                            height="24"
                            color="#fff"
                        />
                        15%
                    </label>
                    <Icon
                        icon="mi:arrow-right"
                        width="1.5rem"
                        height="1.5rem"
                        color="#fff"
                    />
                    <p>De bonificación en toda nuestra propuesta académica.</p>
                </h3>
            )}
            {countryCode === 'AR' && (
                <>
                    <h3>
                        <label>
                            <Icon
                                icon="iconamoon:gift"
                                width="24"
                                height="24"
                                color="#fff"
                            />
                            10%
                        </label>
                        <Icon
                            icon="mi:arrow-right"
                            width="1.5rem"
                            height="1.5rem"
                            color="#fff"
                        />
                        <p>
                            De bonificación en{' '}
                            <b>
                                Programas Especializados, de Formación Ejecutiva
                                o Majors
                            </b>
                            .
                        </p>
                    </h3>
                    <h3>
                        <label>
                            <Icon
                                icon="iconamoon:gift"
                                width="24"
                                height="24"
                                color="#fff"
                            />
                            20%
                        </label>
                        <Icon
                            icon="mi:arrow-right"
                            width="1.5rem"
                            height="1.5rem"
                            color="#fff"
                        />
                        <p>
                            De bonificación en <b>Maestrías o MBA</b>.
                        </p>
                    </h3>
                </>
            )}
            <h3>
                <label>
                    <Icon
                        icon="mdi:infinity"
                        width="24"
                        height="24"
                        color="#fff"
                    />
                    Acceso de por Vida
                </label>
                <Icon
                    icon="mi:arrow-right"
                    width="1.5rem"
                    height="1.5rem"
                    color="#fff"
                />
                <p>Acceso permanente y actualizado al programa cursado.</p>
            </h3>
            <h3>
                <label>
                    <Icon
                        icon="fluent:laptop-person-48-regular"
                        width="24"
                        height="24"
                        color="#fff"
                    />
                    Hibridez
                </label>
                <Icon
                    icon="mi:arrow-right"
                    width="1.5rem"
                    height="1.5rem"
                    color="#fff"
                />
                <p>Combinamos la presencialidad con formación en online.</p>
            </h3>
        </GuestBenefitsWrapper>
    );
};

const GuestBenefitsWrapper = styled.div`
    width: 100%;
    border-radius: 20px;
    background: linear-gradient(180deg, #e51a1a 0%, #b31d15 100%);
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    padding: 2rem;
    box-sizing: border-box;

    h2 {
        font-size: 24px;
        font-weight: 600;
    }

    h3 {
        font-size: 18px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        label {
            display: flex;
            align-items: center;
            gap: 8px;
        }
    }

    p {
        font-weight: 400;
    }

    span {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    @media (max-width: 768px) {
        padding: 1.5rem;

        h2 {
            font-size: 20px;
        }

        h3 {
            font-size: 16px;
        }
    }

    @media (max-width: 480px) {
        padding: 1rem;

        h2 {
            font-size: 18px;
        }

        h3 {
            font-size: 14px;
        }
    }
`;

const Line = styled.div`
    width: 100%;
    height: 1px;
    background: #fff;
`;
